import { useEffect } from 'react';

export function useCardLoadTiming({ sentAt, cardName, logTiming, formatCardLoadTiming }) {
  useEffect(() => {
    if (sentAt) {
      requestAnimationFrame(() => {
        const totalTime = (performance.now() - sentAt) / 1000;
        const formattedTime = formatCardLoadTiming(totalTime);
        logTiming({
          card: cardName,
          time: formattedTime,
        });
        console.log(`${cardName} Total time from request to render: ${formattedTime} s`);
      });
    }
  }, []);
}
